import React, { useEffect, useState } from "react";
import Footer from "../main/Footer";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import axios from "axios";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF"];
const GeoAnalytics = () => {
  const { token } = isAutheticated();
  //Analytics
  const [totalVisitors, setTotalVisitors] = useState(0);
  const [mostVisitedPages, setMostVisitedPages] = useState([]);
  const [searchTrends, setSearchTrends] = useState([]);
  const [activity, setActivity] = useState([]);
  const [dailyVisitors, setDailyVisitors] = useState([]);
  const [browserStats, setBrowserStats] = useState([]);
  const [deviceStats, setDeviceStats] = useState([]);
  const [countryStats, setCountryStats] = useState([]);
  const [sessionDuration, setSessionDuration] = useState(0);
  //
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          visitors,
          pages,
          searches,
          act,
          daily,
          browsers,
          devices,
          countries,
          session,
        ] = await Promise.all([
          axios.get(`${API}/api/analytics/total-visitors`),
          axios.get(`${API}/api/analytics/most-visited`),
          axios.get(`${API}/api/analytics/search-trends`),
          axios.get(`${API}/api/analytics/activity`),
          axios.get(`${API}/api/analytics/daily-visitors`),
          axios.get(`${API}/api/analytics/browser-stats`),
          axios.get(`${API}/api/analytics/device-stats`),
          axios.get(`${API}/api/analytics/country-stats`),
          axios.get(`${API}/api/analytics/session-duration`),
        ]);
        console.log("visitors.data", visitors.data);
        console.log("pages.data", pages.data);
        console.log("Top Searches", searches.data);

        setTotalVisitors(visitors.data.totalVisitors);
        setMostVisitedPages(pages.data);
        setSearchTrends(searches.data);
        setActivity(act.data);
        setDailyVisitors(daily.data);
        setBrowserStats(browsers.data);
        setDeviceStats(devices.data);
        setCountryStats(countries.data);
        setSessionDuration(session.data.avgDuration);
      } catch (error) {
        console.error("Error fetching analytics data", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Analitics */}
          <Container className="py-4">
            <h2 className="text-center mb-4">📊 Analytics</h2>
            <Row className="g-4">
              <Col md={6}>
                <Card className="p-3 text-white bg-primary">
                  <h4>Total Visitors</h4>
                  <h2>{totalVisitors}</h2>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="p-3 text-dark bg-warning">
                  <h4>Avg. Session Duration</h4>
                  <h2>{sessionDuration.toFixed(2)} sec</h2>
                </Card>
              </Col>
            </Row>

            {/* Charts Layout */}
            <Row className="mt-4">
              <Col>
                <h4>🌍 Visitors by Country</h4>
                <BarChart width={600} height={300} data={countryStats}>
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#00C49F" />
                </BarChart>
              </Col>
            </Row>
          </Container>
          {/*  */}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GeoAnalytics;
